// The dependency schema for realtime cache invalidation.
//
// When the LEFT (server) entity changes, every React Query key on the right
// becomes stale and must be refetched. This is THE place that knows which
// views depend on which entity — e.g. an `accounts` change invalidates not
// just the accounts list but net worth (`nw`), emergency fund (`ef`),
// projections and FIRE scores. Add a query that reads an entity → add its key
// here, or it silently won't refresh on a realtime change.
//
// Kept separate from the WebSocket machinery in `realtime.ts` so the schema is
// pure and unit-testable.

export type QueryKey = readonly string[];

// Order doesn't matter; duplicates are harmless.
export const ENTITY_DEPS: Record<string, readonly QueryKey[]> = {
  retirement_targets: [["targets"], ["retirement-projections"], ["fs"]],
  retirement_expense_plan_items: [["plan"]],
  accounts:           [["accounts"], ["nw"], ["ef"], ["retirement-projections"], ["fs"], ["txs"]],
  account_balances:   [["accounts"], ["nw"], ["ef"], ["retirement-projections"]],
  transactions:       [["txs"], ["nw"], ["ef"], ["retirement-projections"], ["fs"]],
  categories:         [["categories"], ["txs"]],
  documents:          [["docs"]],
  budgets:            [["budgets"]],
  webhooks:           [["webhooks"]],
  fx_rates:           [["fx-rates"], ["nw"], ["ef"], ["retirement-projections"], ["fs"]],
  currencies:         [["currencies"]],
  // users — single-user system, ignore for now
};

/** Query keys to invalidate when `entity` changes; `[]` for an unknown entity. */
export function depsFor(entity: string): readonly QueryKey[] {
  return ENTITY_DEPS[entity] ?? [];
}
